import React, {useState, useEffect, useRef, useCallback,} from "react";
import {useSnackbar} from "notistack";
import {db} from "../../../../firebase/Firebase";
import {Filters} from "../../../../utils/HelpFunctions";
import {Layout, LayoutChild} from "../../../../palette/Palette";
import Text from "../../../../palette/Text";
import TextArea from "devextreme-react/text-area";
import {Button} from "devextreme-react/button";
import {LoadIndicator} from "devextreme-react/load-indicator";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import Alerts from "../../../../palette/Alerts";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function ExpressBookingDetail(props) {

    const {setVisible, dataRow, companyName, idCompany, setTrigger, trigger, triggerEffect} = props;

    const [booking, setBooking] = useState({})
    const [valueText, setValueText] = useState('')
    const [textButton, setTextButton] = useState('Actualizar')
    const [load, setLoad] = useState(false)
    const [showTextArea, setShowTextArea] = useState(false)
    const [travelUid, setTravelUid] = useState(null)
    const [travelData, setTravelData] = useState({})
    const [success, setSuccess] = useState(false);

    const {driverId, month, year, date, hour, status} = dataRow

    const {enqueueSnackbar} = useSnackbar();
    const isMounted = useMountedState()

    const mainPath = db.collection(companyName).doc(idCompany).collection('Reservations')
    const bookingPath = db.collection(companyName).doc(idCompany).collection('BookingHistory')
    const travelStatusPath = db.collection(companyName).doc(idCompany).collection('TravelStatus')
    const payments = db.collection(companyName).doc(idCompany).collection('CollectionsPayments')

    useEffect(() => {

        const GetTravelData = async () => {
            await travelStatusPath.doc(year).collection(month).doc(travelUid).get()
                .then(doc => {
                    setTravelData(doc.data())
                })
        }

        if (isMounted()) {
            if (travelUid) {
                GetTravelData().catch(() => {
                })
            }
        }
    }, [travelUid, isMounted])

    useEffect(() => {

        const GetDataBookingPassenger = async () => {
            let dataObject = {}
            let uid = ''
            await mainPath.doc(year).collection(month).where("driverId", "==", driverId)
                .where("date", "==", date).where("hour", "==", hour).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        dataObject = {...doc.data(), docId: doc.id}
                        uid = doc.id
                    });
                    setBooking(dataObject)
                    setTravelUid(dataObject.travelStatusUid)
                })
        }

        if (isMounted()) {
            GetDataBookingPassenger().catch(() => {
            })
        }
    }, [isMounted, dataRow, triggerEffect])

    const GetCollectionPayments = async (cod) => {
        return await payments.doc(year).collection(month).where("codPassenger", "==", cod).get()
            .then(querySnapshot => {
                let dataObj;
                querySnapshot.forEach(doc => {
                    dataObj = {...doc.data(), docId: doc.id}
                })
                return dataObj
            }).catch(() => {
                /*console.log(e)*/
            })

    }

    const Success = () => {
        setTimeout(() => {
            setSuccess(false)
            setShowTextArea(false)
            setBooking([])
            setValueText('')
            setTextButton('Actualizar')
            setVisible(false)
            setTrigger(!trigger)
        }, 2000)
    }

    const onTextAreaValueChanged = (e) => {
        if (e.value !== '') {
            setValueText(e.value)
        }
    }

    const cancelExpress = async () => {
        if (valueText === '') {
            NotiStackInfo('Ingrese la observacion.', 'error', enqueueSnackbar)
            return
        }

        const idReservation = booking.docId
        const idHistory = dataRow.docId

        setLoad(true)
        setTextButton('Cancelando')

        if (status === 'Confirmado') {
            const updateHistory = {
                ...dataRow,
                seating: 0,
                numberSeats: 0,
                paymentValue: 0,
                observationBooking: [valueText],
                status: 'Cancelado'
            }

            const updateTravelData = {...travelData, numberPassengers: 0, status: 'Cancelado'}


            try {
                await mainPath.doc(year).collection(month).doc(idReservation).delete()
                await bookingPath.doc(year).collection(month).doc(idHistory).set(updateHistory)
                await travelStatusPath.doc(year).collection(month).doc(travelUid).set(updateTravelData)
                setSuccess(true)
                Success()
            } catch (e) {
                setShowTextArea(false)
                setValueText('')
                setTextButton('Actualizar')
                setLoad(false)
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            }


        } else {

            const updateHistory = {
                ...dataRow,
                numberParcels: 0,
                paymentValue: 0,
                numberSeats: 0,
                observationBooking: [valueText],
                status: 'Semi completado'
            }

            const updateTravelData = {
                ...travelData, status: 'Finalizado(Obs.)', totalParcels: 0, onBoard: 1,
                numberPassengers: 0
            }

            const dataPayments = await GetCollectionPayments(dataRow.cod)

            const paymentsUid = dataPayments?.docId
            const valueCollect = 0

            const updateDataPayments = {
                ...dataPayments, paymentValue: 0, valueCollect: valueCollect,
                netCompany: valueCollect, numberParcels: 0, grossValue: valueCollect
            }

            try {
                await bookingPath.doc(year).collection(month).doc(idHistory).set(updateHistory)
                await travelStatusPath.doc(year).collection(month).doc(travelUid).set(updateTravelData)
                await payments.doc(year).collection(month).doc(paymentsUid).set(updateDataPayments)
                setSuccess(true)
                Success()
            } catch (e) {
                setShowTextArea(false)
                setValueText('')
                setTextButton('Actualizar')
                setLoad(false)
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar);
            }
        }
    }


    return (
        <div>
            <LayoutChild color={'#FFA95C'} padding={7} width={150}>
                <Text hover={false} text={`ESTADO :  ${dataRow?.status.toUpperCase()}`} color={'#FFFFFF'}
                      weight="bold" size={10}/>
            </LayoutChild>
            <div style={{border: '1px solid #B0BEC5', marginTop: 12, borderRadius: 3}}>
                <LayoutChild percent={100} color={'#EEF4FD'} padding={7} row>
                    <LayoutChild percent={50}>
                        {dataRow.type === 'P' &&
                        <Text hover={false} text={`Detalle del viaje reservado para :`} weight="bold" size={10}/>}
                        {dataRow.type === 'E' &&
                        <Text hover={false} text={`Detalle de la encomienda para:`} weight="bold" size={10}/>}
                        <Text hover={false} text={dataRow.passenger} weight="500" size={9} top={4}/>
                        <Text hover={false} text={`Viaje de ${dataRow.routeName}`} weight="600" size={8}/>
                        <Text hover={false} text={`Fecha : ${dataRow.date} a las ${dataRow.hour} `}
                              weight="400" size={8} top={3}/>

                    </LayoutChild>
                    <LayoutChild percent={50} positionR>
                        <Layout row center positionR>
                            <Text hover={false} text={`COD :`} weight="700" size={11}/>
                            <Text hover={false} text={`${dataRow.cod}`} weight="700" size={11} color={'#FFA95C'}
                                  left={10}/>
                        </Layout>
                        <div style={styles.driverContainer}>
                            <Text hover={false} text={`Vehículo conducido por:`} weight="bold" size={8}/>
                            <Text hover={false} text={dataRow.driver} weight="500" size={8} top={4}/>
                        </div>
                    </LayoutChild>
                </LayoutChild>
                <LayoutChild percentage={100} padding={8} color={'#FAFAFA'}>
                    <Text hover={false} text={'Observaciones'} weight="bold" size={10}/>
                    <TextArea
                        height={90}
                        value={valueText}
                        onFocusIn={() => setShowTextArea(true)}
                        onValueChanged={onTextAreaValueChanged}/>

                </LayoutChild>
                {success && <Alerts severity={'success'} body={'Cancelación realizada exitosamente'}/>}
                <LayoutChild percentage={100} padding={8} color={'#FAFAFA'} row space>
                    <Button id="cancel-button"
                            icon="fas fa-ban"
                            text="Cancelar"
                            onClick={() => {
                                setShowTextArea(false)
                                setBooking([])
                                setValueText('')
                                setVisible(false)
                            }}/>
                    < Button
                        width={130}
                        id={'load-button'}
                        icon={'far fa-edit'}
                        type={'success'}
                        disabled={(!showTextArea || load)}
                        onClick={cancelExpress}
                    >
                        <Layout row center positionC>
                            <LoadIndicator className="button-indicator" visible={load} id="small-indicator" height={20}
                                           width={20}/>
                            <span className="dx-button-text">{textButton}</span>
                        </Layout>
                    </Button>
                </LayoutChild>
            </div>
        </div>
    )
}

export default ExpressBookingDetail

const styles = {
    driverContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        width: '100%',
        marginTop: 3
    }
}